import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router'


export const Route = createFileRoute('/_clients/tempula')({
  component: RouteComponent,
  notFoundComponent: () => <Navigate to="/tempula/home" replace />
})

function RouteComponent() {
  return <div >
      <Outlet />
    </div>
}
